<template>
  <div>
    <datepicker class="datePicker" :placeholder="'select '+fname" v-model="date"></datepicker>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
export default {
  name: "Date",
  props: ["slg", "fname", "index", "value"],
  components: {
    Datepicker
  },
  data() {
    return {
      date: "",
      error: ""
    };
  },
  mounted() {
    if (new Date(this.value) != "Invalid Date" || !this.value) {
      this.date = this.value;
    } else {
      this.date = this.value.toDate();
    }
  },
  watch: {
    date() {
      this.$emit("input", this.date);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.vdp-datepicker__calendar .cell.selected {
  background: #4d8cf4 !important;
  color: white;
}
.light .vdp-datepicker input {
  background-color: #f5f6fa;
  color: #353536;
}

.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
  border: 1px solid #4d8cf4 !important;
}

.vdp-datepicker input {
  height: 40px;
  border-style: none;
  border-radius: 3px;
  background-color: #1f2228;
  color: #cdd0d4;
  font-size: 16px;
  display: block;
  padding: 8px 12px;
  margin-bottom: 10px;
}
.datePicker {
  color: #333;
}
.date {
  border: 1px solid transparent;
  font-family: sans-serif;
}
</style>